export default "__VITE_ASSET__9d32369c__"